import {AfterContentInit, Component, Input, TemplateRef, ViewChild} from '@angular/core';

@Component({
    selector: 'lib-rc-table-drawer',
    template: `<ng-template #tableDrawer>
    <div class="rc-table-drawer">
        <ng-content></ng-content>
    </div>
</ng-template>
`,
    styles: [``]
})
export class RcTableDrawerComponent implements AfterContentInit {
    @Input() rowData: any = {};

    @ViewChild('tableDrawer', {read: TemplateRef}) tableDrawer;

    ngAfterContentInit() {

    }

}
